import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://9bb977920c4a49dfb9f88691a38977c3@o486889.ingest.sentry.io/5958233',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1,
    environment: process.env.REACT_APP_ENV,
    ignoreErrors: ['Non-Error promise rejection captured with value:']
  });
};
